"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const framer_motion_1 = require("framer-motion");
const __1 = require("../..");
const helpers_1 = require("../../lib/helpers");
const TabButtons = (props) => {
    const { children } = props;
    const newTabs = [];
    const injectedChildren = react_1.default.Children.map(children, (child) => {
        var _a, _b, _c;
        if (typeof child === 'object' && ((_a = child === null || child === void 0 ? void 0 : child.type) === null || _a === void 0 ? void 0 : _a.displayName) === 'j-tab-button') {
            // enforce a name of a <TabButton>
            const childName = (_c = (_b = child === null || child === void 0 ? void 0 : child.props) === null || _b === void 0 ? void 0 : _b.name) !== null && _c !== void 0 ? _c : newTabs.length;
            const newChild = react_1.default.cloneElement(child, { name: childName });
            newTabs.push(childName);
            return newChild;
        }
        return child;
    });
    const primitiveProps = helpers_1.usePrimitiveProps(props);
    return (react_1.default.createElement("div", Object.assign({}, primitiveProps),
        react_1.default.createElement(framer_motion_1.AnimateSharedLayout, null, injectedChildren)));
};
exports.default = __1.withJourney('j-tab-buttons', TabButtons);
